import { isNil } from 'lodash'
import { ActivityAction, ActivityObjectType, type Activity } from '../../types'
import { t } from 'i18next'
export const createActivityTitle = (activity: Activity): string => {
  if (activity.object.type === ActivityObjectType.Agent) {
    const suffix =
      activity.action === ActivityAction.Activate
        ? t('activityfeed:agent_activated_suffix')
        : t('activityfeed:agent_completed_suffix')
    return `${activity.object.name} ${suffix}`
  }

  if (!isNil(activity) && activity.object.type === ActivityObjectType.Decision) {
    const outcomeSubactivity = activity.sub_activities.find(
      a => !isNil(a?.text?.en) && a.text.en.includes('Evaluated outcome')
    )
    const outcomeText = outcomeSubactivity?.text?.en ?? ''
    return `Decision - ${outcomeText}`
  }
  return activity?.action_component?.title ?? activity?.object?.name ?? ''
}
